var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTooltipFunnelDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "currentColor",
  rx: 10
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.87 11.81v-.495c0-.396.089-.847.661-1.343l.55-.473c.396-.33.715-.726.715-1.353 0-.65-.44-1.079-1.188-1.079-.77 0-1.288.463-1.288 1.277 0 .176.011.319.067.572l-1.321-.132A3 3 0 0 1 7 8.168C7 6.89 7.946 6 9.63 6c1.607 0 2.564.748 2.564 2.069 0 .781-.473 1.452-1.034 1.947l-.529.463c-.34.297-.462.55-.462 1.012v.32zM8.784 14v-1.408h1.496V14z"
})));
export default SvgTooltipFunnelDefault;